import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import ModalHeader from '../../modal/ModalHeader.react';
import Button from '../Button.react';
var Confirm = function Confirm(_ref) {
  var onConfirm = _ref.onConfirm,
    _ref$onCancel = _ref.onCancel,
    onCancel = _ref$onCancel === void 0 ? null : _ref$onCancel,
    hideModalAction = _ref.hideModalAction;
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Are You Sure?"
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body confirmation-modal__body"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "No!",
    type: "cancel",
    onClick: function onClick() {
      if (onCancel) onCancel();
      hideModalAction();
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Yes!",
    onClick: function onClick() {
      if (onConfirm) onConfirm();
      hideModalAction();
    }
  })));
};
var mdtp = {
  hideModalAction: modalActions.hide
};
export default connect(null, mdtp)(Confirm);